import React from 'react';
import { observer } from 'mobx-react';
import userStore from '../Stores/User';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';

const ReferralLanding = observer(({ referralUuid }) => {
  const history = useHistory();

  const handleGetStarted = () => {
    // Track referral click
    mixpanel.track('Referral Landing: Get Started Clicked', {
      referral_uuid: referralUuid
    });
    
    // Store referral info in localStorage for when user signs up
    localStorage.setItem('pendingReferral', JSON.stringify({
      uuid: referralUuid,
      config: {
        type: 'referral',
        couponCode: 'REFERRAL',
        utmSource: 'referral'
      },
      returnUrl: `/onboarding/ChooseVoice?referral=${referralUuid}`
    }));
    
    // Redirect to signin with referral tracking
    history.push('/signin?redirected_from=referral');
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      textAlign: 'center',
      fontFamily: 'Cabin, sans-serif'
    }}>
      {/* Logo */}
      <div style={{ marginBottom: '40px' }}>
        <img 
          src="/logo192.png" 
          alt="Audioread" 
          style={{
            width: '80px',
            height: '80px',
            marginBottom: '20px'
          }}
        />
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: '600px', marginBottom: '40px' }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: 'bold',
          marginBottom: '20px',
          background: 'linear-gradient(45deg, #4ade80, #22c55e)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          🎁 You've Been Invited!
        </h1>
        
        <p style={{
          fontSize: '1.2rem',
          marginBottom: '20px',
          opacity: 0.9,
          lineHeight: '1.6'
        }}>
          Your friend thinks you'd love Audioread! Get started with your free trial and enjoy premium audio content.
        </p>

        <div style={{
          backgroundColor: 'rgba(74, 222, 128, 0.1)',
          border: '2px solid rgba(74, 222, 128, 0.3)',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <h2 style={{
            color: '#4ade80',
            fontSize: '1.5rem',
            marginBottom: '15px'
          }}>
            🎉 Special Referral Offer
          </h2>
          <p style={{
            fontSize: '1.1rem',
            marginBottom: '10px',
            fontWeight: '600'
          }}>
            FREE for 7 days + 1 month!
          </p>
          <p style={{
            fontSize: '1rem',
            opacity: 0.8
          }}>
            Then $69.00/year, only $1.35/week
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(24,15,34,0.5)',
          borderRadius: '8px',
          padding: '20px',
          marginBottom: '30px'
        }}>
          <h3 style={{
            fontSize: '1.2rem',
            marginBottom: '15px',
            color: '#4ade80'
          }}>
            What you get with Audioread:
          </h3>
          <ul style={{
            textAlign: 'left',
            listStyle: 'none',
            padding: 0
          }}>
            <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#4ade80', marginRight: '10px' }}>✓</span>
              Convert any link, file, email, or text into high-quality audio
            </li>
            <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#4ade80', marginRight: '10px' }}>✓</span>
              Listen on your podcast player or any browser
            </li>
            <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#4ade80', marginRight: '10px' }}>✓</span>
              100+ human voices in 80+ languages
            </li>
            <li style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
              <span style={{ color: '#4ade80', marginRight: '10px' }}>✓</span>
              AI summaries and adjustable playback speed
            </li>
          </ul>
        </div>
      </div>

      {/* CTA Button */}
      <button
        onClick={handleGetStarted}
        style={{
          padding: '20px 40px',
          fontSize: '1.2rem',
          fontWeight: 'bold',
          backgroundColor: '#4ade80',
          color: '#000',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          boxShadow: '0 4px 12px rgba(74, 222, 128, 0.3)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.05)';
          e.target.style.boxShadow = '0 6px 16px rgba(74, 222, 128, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 12px rgba(74, 222, 128, 0.3)';
        }}
      >
        Start Your Free Trial
      </button>

      {/* Footer */}
      <div style={{
        marginTop: '40px',
        opacity: 0.6,
        fontSize: '0.9rem'
      }}>
        <p>Cancel anytime</p>
        <p>Your friend gets 1 million extra characters when you sign up!</p>
      </div>
    </div>
  );
});

export default ReferralLanding;
